import { Link } from "react-router-dom";
import NotificationItem from "./NotificationItem";
import type { NotificationItemModel } from "../types";

interface NotificationDropdownProps {
  items: NotificationItemModel[];
  onViewAllClick?: () => void;
}

const NotificationDropdown = ({
  items,
  onViewAllClick,
}: NotificationDropdownProps) => {
  return (
    <div className="absolute right-0 top-10 z-50 w-[min(360px,90vw)] border border-black bg-white text-black ">
      <div className="flex items-center justify-between border-b border-[#EFEFEF] px-4 py-3">
        <h3 className="text-base font-semibold text-black">Notifications</h3>
      </div>

      <div>
        {items.map((item) => (
          <NotificationItem key={item.id} item={item} />
        ))}
      </div>

      <div className="border-t border-[#EFEFEF] px-4 py-3 text-center">
        <Link
          to="/notifications"
          className="text-xs text-center font-medium text-[#6A7282]"
          onClick={onViewAllClick}
        >
          View all notifications
        </Link>
      </div>
    </div>
  );
};

export default NotificationDropdown;
